$(document).on('click', ".dnBusinessPackages-title", function () {
    var column = $(this).data('column');
    packageSelect(column);
});

function packageSelect(column) {
    $('.dnBusinessPackages-row').each(function () {
        $(this).find('span').each(function (index) {
            if (column == index && index) {
                $(this).addClass('dnBusinessPackages-pack-active');
                $(this).removeClass('dnBusinessPackages-pack-off');
            } else {
                $(this).addClass('dnBusinessPackages-pack-off');
                $(this).removeClass('dnBusinessPackages-pack-active');
            }
        });
    });
}

$(document).ready(function () {
    packageSelect(2);
});


$(document).scroll(function () {
    if ($('.dnBusinessPackages').length) {

        var y = $(this).scrollTop();
        var posPackageTop = $('.dnBusinessPackages-container').offset().top;
        var posPackageBottom = $('.dnBusinessPackages-container').offset().top + $('.dnBusinessPackages-container').outerHeight(true) - 70;
        if (y > posPackageTop && y < posPackageBottom) {
            $('.dnBusinessPackages-headline').addClass("dnBusinessPackages-headline-fixed");
            $('.dnBusinessPackages-container').addClass("dnBusinessPackages-container-fixed");
            $('.dnBusinessPackages-headline').addClass("container");
            $('.dnBusinessPackages-headline').addClass("row");
        } else {
            $('.dnBusinessPackages-headline').removeClass("dnBusinessPackages-headline-fixed");
            $('.dnBusinessPackages-container').removeClass("dnBusinessPackages-container-fixed");
            $('.dnBusinessPackages-headline').removeClass("container");
            $('.dnBusinessPackages-headline').removeClass("row");
        }

    }
});